export const STATUS_COLORS: Record<string, string> = {
  verified: '#2F81F7',
  deployed: '#3FB950',
  audited: '#A371F7',
  compensated: '#FF9500',
  'to do': '#E3B341',
  // na: '#94A3B8',
  'not applicable': '#94A3B8',
  open: '#FF8A4C',
  closed: '#4ADE80',
  reopened: '#FFE066',
  mitigated: '#3FB950',
};

export const PRIORITY_COLORS: Record<string, string> = {
  'do now': '#EF4444',
  'do soon': '#FF9500',
  'do later': '#3FB950',
};

export const RISK_COLORS: Record<string, string> = {
  critical: '#A90000',
  high: '#EF4444',
  medium: '#FF9500',
  low: '#3FB950',
  'not applicable': '#94A3B8',

};
export const DARK_COLORS: Record<string, string> = {
  'to do': '#E3B341',
  deployed: '#34C759',
  'not applicable': '#94A3B8',
};

export const COLORS: Record<string, string> = {
  verified: '#2F81F7',
  deployed: '#3FB950',
  audited: '#A371F7',
  compensated: '#FF9500',
  'to do': '#E3B341',
  na: '#94A3B8',
  'not applicable': '#94A3B8',
  'do now': '#EF4444',
  'do soon': '#FF9500',
  'do later': '#3FB950',
  critical: '#A90000',
  high: '#EF4444',
  medium: '#FF9500',
  low: '#3FB950',
  // New categories
  governance: '#7B49F0',
  gov: '#7B49F0',
  'automation & artificial intelligence': '#FF9D3B',
  aai: '#FF9D3B',
  'governance – asset management': '#50AAFF',
  'business continuity planning': '#67E57A',
  bcp: '#67E57A',
  'governance - capacity & performance planning': '#FF6B6B',
  'governance – change management': '#FFE066',
  cloud: '#4DBFFF',
  cld: '#4DBFFF',
  'governance – compliance management': '#C084FC',
  'governance – configuration management': '#4ADE80',
  monitoring: '#FFB454',
  mon: '#FFB454',
  data: '#077EFC',
  dat: '#077EFC',
  'cyber physical systems': '#312E81',
  cps: '#312E81',
  endpoint: '#00CC3D',
  end: '#00CC3D',
  user: '#FF3285',
  usr: '#FF3285',
  infrastructure: '#848484',
  inf: '#848484',
  'monitoring – incident response': '#75C1F8',
  'gov – security program management': '#FFA81B',
  privacy: '#FF6C63',
  prv: '#FF6C63',
  'governance - risk': '#3FECFF',
  development: '#D54042',
  dev: '#D54042',
  'gov – vendor risk management': '#CD44FB',
  'monitoring – threat intelligence': '#DFD805',
  'cloud web security': '#5472D5',
  'identity & access management': '#FF689F',
  web: '#FF689F',
  open: '#FF8A4C',
  closed: '#4ADE80',
  reopened: '#FFE066',
};


export const getColor = (map: Record<string, string>, key: string): string => {
  return map[key?.toLowerCase()];
};

const GLOBAL_COLOR_MAPS = [PRIORITY_COLORS, STATUS_COLORS, RISK_COLORS];

export function getGlobalColor(key: string): string {
  for (const map of GLOBAL_COLOR_MAPS) {
    if (map[key]) return map[key];
  }
  return '#808080'; // fallback
}
export const BADGE_CLASS_MAP: Record<string, string> = {
  Critical: 'badge-danger',
  High: 'badge-high dark:badge-high',
  Medium: 'badge-warning',
  Mitigated: 'badge-mitigated dark:badge-mitigated',
  Low: 'badge-low dark:badge-low',
  Open: 'badge-high dark:badge-high',
  Closed: 'badge-low dark:badge-low',
  Reopened: 'badge-warning',
};

export function getBadgeClass(impact: string): string {
  return BADGE_CLASS_MAP[impact] || '';
}
